import { Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { COLORS } from "../../theme";

const defaultProps = {
  fontWeight: "normal",
  color: COLORS.black,
};

export const H5 = ({ children, fontWeight, color, fontStyle, fontFamily }) => {
  return (
    <Typography variant="h5" sx={{ fontWeight, color, fontStyle, fontFamily }}>
      {children}
    </Typography>
  );
};

H5.propTypes = {
  fontWeight: PropTypes.string,
  color: PropTypes.string,
};

H5.defaultProps = defaultProps;

export default H5;
